export var defaultHtml5VideoState = {
    url: '',
};
//# sourceMappingURL=state.js.map